// extracted by mini-css-extract-plugin
export const mainContainer = "Styles-module--mainContainer--1iexw";
export const frontBack = "Styles-module--frontBack--30EPe";
export const back = "Styles-module--back--f4PJT";
export const image = "Styles-module--image--2X0wQ";
export const label = "Styles-module--label--1yr5a";